import { render, staticRenderFns } from "./void.vue?vue&type=template&id=c2d0a22c&scoped=true"
import script from "./void.vue?vue&type=script&lang=js"
export * from "./void.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d0a22c",
  null
  
)

export default component.exports